import { useFetch } from "@common/hooks/useFetch";
import { useEffect } from "react";
import { ROUTES } from "@constants";
import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";
import { getProspectId } from "@utils/storage";
import { customerDetailsRoute,customerDetailsCrossSellRoute } from "@api-routes";
import { fixUrlLanguage } from "@utils/changeLanguage";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";

export const useGetCustomerDetails = (
    push: (route: string) => void,
    callback: (customerDetails?: ICustomerDetails) => void
) => {
    const [getCustomerDetailsState, { get }] = useFetch();

    const getCustomerDetails = () => {
        const prospectId = getProspectId();

        if (prospectId) {
            get<ICustomerDetails>(keycloakUtils.isAuthenticated()?customerDetailsCrossSellRoute():customerDetailsRoute(), {
                isSecured: keycloakUtils.isAuthenticated(),
            }).then((customerDetailsResult) => {
                callback(customerDetailsResult);
            });
        } else {
            push(fixUrlLanguage(ROUTES.HOME_PAGE_URL_EN));
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getCustomerDetails, []);

    return { getCustomerDetailsState, getCustomerDetails };
};
